import { useState } from "react";
import { Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { STATUS_META, STATUS_ORDER } from "@/lib/constants";

export const Semaphore = ({ status, labels, onChange, size = "md" }) => {
  const [open, setOpen] = useState(false);
  const meta = STATUS_META[status] || STATUS_META.gris;
  const dot = size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3";

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="semaphore-indicator"
          onClick={(e) => e.stopPropagation()}
          className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold transition-all hover:opacity-90 hover:shadow-sm"
          style={{ backgroundColor: meta.bg, color: meta.text, border: `1px solid ${meta.border}` }}
        >
          <span className={`${dot} rounded-full`} style={{ backgroundColor: meta.hex }} />
          {labels?.[status] || meta.name}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56" onClick={(e) => e.stopPropagation()}>
        {STATUS_ORDER.map((key) => {
          const m = STATUS_META[key];
          return (
            <DropdownMenuItem
              key={key}
              data-testid={`semaphore-option-${key}`}
              className="flex items-center gap-2.5 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                onChange?.(key);
              }}
            >
              <span className="h-3 w-3 rounded-full" style={{ backgroundColor: m.hex }} />
              <span className="flex-1 text-sm">{labels?.[key] || m.name}</span>
              {status === key && <Check className="h-4 w-4 text-slate-500" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
